import styled from 'styled-components'
import { Flex, Surface, Colors, Button } from '@pinchenterprisesnpm/friday-ui'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const StepperContainer = styled(Flex)<{ menuWidth: string }>`
  height: 100%;
  width: calc(100% - ${({ menuWidth }) => menuWidth});
  overflow: hidden;
  position: fixed;
`

export const BackButtonContainer = styled(Flex)`
  width: 100%;
  padding: ${({ theme: { mp } }) => mp.sm} ${({ theme: { mp } }) => mp.md};
  background: ${({ theme: { palette } }) => palette.white};
  align-items: center;
  margin-bottom: ${({ theme: { mp } }) => mp.xs};
`

export const BusinessName = styled.span`
  color: ${({ theme: { palette } }) => palette.primary};
  font-weight: 700;
`

export const StepHeader = styled(Surface)`
  display: flex;
  align-items: center;
  padding: 16px;
  box-sizing: border-box;
  border-radius: 4px;
  height: 70px;
  margin-bottom: 10px;
`

export const HeaderIcon = styled(FontAwesomeIcon)`
  height: 26px;
  width: 26px;
  color: ${Colors.primary};
  margin-right: 20px;
`

export const HeaderTitle = styled.h4`
  margin: 0;
  color: ${Colors.secondary};
  font-family: Roboto;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
  margin-right: 5px;
`

export const StepNavigation = styled(Flex)`
  background-color: ${Colors.background};
  margin-top: 85px;
  padding-bottom: ${({ theme }) => theme.mp.xl};
  padding-left: ${({ theme }) => theme.mp.sm};
  padding-right: ${({ theme }) => theme.mp.sm};
  padding-top: ${({ theme }) => theme.mp.xl};
  max-height: 100%;
  overflow-y: auto;
  width: 280px;
`

export const StyledIcon = styled(FontAwesomeIcon)`
  margin-right: 11px;
  height: 22px;
  width: 22px;
  color: inherit;
`

export const CompletedIcon = styled(FontAwesomeIcon)`
  margin-left: auto;
  color: ${Colors.success};
  height: 22px;
  width: 22px;
`

export const ErrorIcon = styled(FontAwesomeIcon)`
  margin-left: auto;
  color: ${Colors.danger};
  height: 22px;
  width: 22px;
`

export const TagWrapper = styled.span`
  margin-left: 7px;
  margin-right: auto;
  display: flex;
  align-items: center;
`

export const StepButton = styled.button<{
  $isActive: boolean
  $navigationDisabled?: boolean
}>`
  width: 100%;
  max-width: 280px;
  padding: 10px;
  margin-bottom: 5px;
  text-align: left;
  border: 2px solid ${(props) => (props.$isActive ? Colors.primary_600 : Colors.border)};
  background-color: ${(props) => (props.$isActive ? Colors.hover : Colors.white)};
  color: ${(props) => (props.$isActive ? Colors.primary_600 : Colors.additional)};
  border-radius: 4px;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: ${(props) => (props.$isActive ? '500' : '400')};
  line-height: 140%;
  cursor: ${(props) =>
    props.$navigationDisabled ? 'default' : props.$isActive ? 'default' : 'pointer'};
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  height: 42px;

  ${(props) =>
    !props.$navigationDisabled && !props.$isActive
      ? `
    &:hover {
      border-color: ${Colors.primary_600};
      color: ${Colors.primary_600};
    }
  `
      : ''}

  &:last-child {
    margin-bottom: 0;
  }
`

export const StepContent = styled(Flex)`
  flex: 1;
  flex-direction: column;
  padding-top: ${({ theme }) => theme.mp.xs};
  padding-right: ${({ theme }) => theme.mp.xs};
  min-height: 0;
  position: relative;
  width: 100%;
`

export const StepContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: visible;
  min-height: 0;
`

export const StepComponentWrapper = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  padding-bottom: 140px;
`

export const StepHFooter = styled(Surface)`
  width: calc(100% - 280px);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  padding: 16px;
  box-sizing: border-box;
  border-radius: 4px;
  height: 70px;
  flex-shrink: 0;
  margin-top: 10px;
  position: fixed;
  bottom: 0;
  background-color: ${Colors.white};
  z-index: 1000;
  border-top: 1px solid ${Colors.border};
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
`

export const FooterButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 2px;
  height: 42px;
`

export const ButtonIcon = styled(FontAwesomeIcon)<{
  position: 'left' | 'right'
}>`
  height: 14px;
  width: 14px;
  ${(props) => (props.position === 'left' ? 'margin-right: 4px;' : 'margin-left: 4px;')}
`
